/**
 * Handle smart gateway reading interval kind
 */
export enum ReadingInterval {
  DAILY = 0,
  WEEKLY = 1,
  MONTHLY = 2,
}
